import { Timeline } from 'antd';
import React, { useState } from 'react';
import classNames from 'classnames';
import "./TimelineProgress.scss"


const TimelineProgress = ({ stepList }) => {
    return (
        <>
            <Timeline mode={"left"}>
                {
                    stepList?.map((step) => {
                        return (
                            <Timeline.Item label={step.time}>
                                <div className={classNames({

                                    "contentBox1": step.title === "Complaint assigned",
                                    "contentBox2": step.title === "Complaint resolved",
                                    "contentBox": step.title !== "Complaint assigned" && step.title !== "Complaint resolved",
                                })}>
                                    <div className="titleLabel">{step.title}</div>
                                    {step.title !== "Complaint resolved" ?
                                        <div className="description">{step.description}</div>
                                        :
                                        <>
                                            <div className="description">{`Resolution remarks : ${step.description}`}</div>
                                        </>
                                    }
                                    {step.title === "comment" ?
                                        <>
                                            {step?.commented_user && <div className="description">{`-- ${step.commented_user} (${step.commented_by})`}</div>}
                                        </>
                                        :
                                        <div className="message">{step.message}</div>
                                    }
                                </div>
                            </Timeline.Item>
                        )
                    })
                }
            </Timeline>
        </>
    );
};

export default TimelineProgress;